import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/social/share`;

export class Social {
  static async shareFacebook(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/facebook/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
          responseType: 'blob',
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async shareLinkedIn(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/linkedin/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
          responseType: 'blob',
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async shareTwitter(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/twitter/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
          responseType: 'blob',
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async shareEmail(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/email/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
          responseType: 'text/plain',
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async share(platform, repositoryId, documentId, params) {
    switch (platform.toLowerCase()) {
      case 'facebook':
        return this.shareFacebook(repositoryId, documentId, params);
      case 'linkedin':
        return this.shareLinkedIn(repositoryId, documentId, params);
      case 'twitter':
        return this.shareTwitter(repositoryId, documentId, params);
      case 'email':
        return this.shareEmail(repositoryId, documentId, params);
      default:
        throw new Error(`Unsupported platform: ${platform}`);
    }
  }
}
